import React, { useContext, useEffect, useState } from 'react';
// AUTH
import { AuthContext } from '../contexts/AuthContext.js';
// REACT ROUTER
import { useNavigate, useLocation } from 'react-router-dom';
// AXIOS
import axios from 'axios';
// REACT HOOK FORM
import { useForm } from "react-hook-form";
// REACT SELECT
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
// REACT SWEETALERT
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
// REACT SPINNER
import { Watch } from 'react-loader-spinner';
// DYNAMIC ICON
import DynamicIcon from '../partials/DynamicIcon.js';
// BOOTSTRAP
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';

function ActivitiesDuplicate() {
  // AUTH, STATE, NAVIGATION
  const { authobj } = useContext(AuthContext);
  const { state } = useLocation();
  let navigate = useNavigate();
  // FORM
  const { register, handleSubmit, reset, setValue, formState: { errors }  } = useForm();
  // SWEETALERT
  const MySwal = withReactContent(Swal);
  // DATA
  const [activity, setActivity] = useState(null);
  const [activityOperations, setActivityOperations] = useState([]);
  const [activityPriorities, setActivityPriorities] = useState([]);
  const [locations, setLocations] = useState([]);
  const [duplicates, setDuplicates] = useState([]);
  const [selectLocations, setSelectLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  // SPINNER
  const [wait, setWait] = useState(false);

  useEffect(() => {
    setWait(true);

    if (state && state.activity_id) {
      setWait(true);
      axios.post(window.SERVER_URL+'activities/get', { id: state.activity_id }, { headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer '+authobj.token
      }}).then(res => {
        console.log(res.data);
        setActivity(res.data);
        setActivityOperations(res.data.activity_operations);

        setWait(false);
      });
    } else {
      setWait(false);
      navigate('/activities');
    }
  }, [reset, state.activity_id]);

  // Fetch delle opzioni per la select
  const fetchOptions = (inputValue) => {
    if (!inputValue || inputValue.length < 3) {
      return Promise.resolve([]);
    } else {
      return axios.post(window.SERVER_URL+'locations/filter', { 'query': inputValue }, { headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer '+authobj.token
      }}).then(res => {
        setLocations(res.data.locations);
        let select_options = [];
        res.data.locations.map((loc) => {
          select_options.push({ value: loc.id, label: loc.denominazione });
        });
        setSelectLocations(select_options);
        console.log(select_options);
        return select_options;
      });
    }
  }

  const handleInputChange = (inputValue, { action }) => {
    if (action === "input-change" && inputValue === "") {
      setSelectLocations([]); // Clear cached options when search text is cleared
    }
  };

  const handleChange = (selectedOption) => {
    setSelectedLocation(selectedOption);
    if (!selectedOption) {
      setSelectLocations([]); // Clear cached options when selection is cleared
    }
  };

  const addLocation = () => {
    if (selectedLocation) {
      setDuplicates([...duplicates, selectedLocation]);
    }
  }

  const delLocation = (location_id) => {
    setDuplicates(duplicates.filter((loc) => loc.value !== location_id));
  }

  // Submit della form
  const onSubmit = (form_data) => {
    if (duplicates.length) {
      console.log(form_data);
      form_data.user_id = authobj.user_id;
      form_data.activity_id = activity ? activity.id : null;
      form_data.locations = duplicates.map((loc) => loc.value);
      axios.post(window.SERVER_URL+'activities/duplicate', form_data, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Authorization': 'Bearer '+authobj.token,
        }
      }).then(res => {
        if (res.data.ret.success) {
          Swal.fire({
            icon: 'success',
            title: 'Intervento duplicato',
            text: "L'intervento è stato duplicato con successo"
          }).then(() => {
            navigate('/activities');
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Attenzione',
            text: 'Si è verificato un errore durante la duplicazione'
          });
        }
      }).catch(function(error) {
        console.log(error);
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Attenzione',
        text: 'Non hai selezionato ubicazioni su cui duplicare'
      });
    }
  }

  return (
    <>
      { wait ? 
        <div id="wait">
          <Watch height="80" width="80" radius="48" color="#44B2EB" ariaLabel="watch-loading" wrapperStyle={{}} wrapperClassName="" visible={true} />
        </div>
      : '' }
      <Container className="content">
        <Row className="page_title">
          <Col>
            <h1>Duplica intervento</h1>
          </Col>
        </Row>
        { activity ?
          <Row className="activity_info">
            <Col className="title" lg={3}>
              <h2>Informazioni intervento</h2>
              <div className='action_bar bottom' style={{'padding':'0','margin':'0'}}>
                <Button onClick={() => navigate('/activities/add', { state: { activity_id: state.activity_id } }) } style={{'margin':'0'}}><DynamicIcon iconName="IoIosArrowBack" /> Torna all'intervento</Button>
              </div>
            </Col>
            <Col>
              { activity ? 
                <ul>
                  <li><b>Sede tecnica:</b> { activity.location.sede_tecnica }</li>
                  {/* <li><b>Data preventivata:</b> { activity.data_preventivata ? activity.data_preventivata.split('-').reverse().join('/') : '' }</li> */}
                  <li><b>Priorità:</b> { activity.activity_priority.descrizione }</li>
                  <li><b>Ubicazione:</b> { activity.location.denominazione }</li>
                  <li><b>Indirizzo:</b> { activity.location.indirizzo }</li>
                  <li><b>Creato il:</b> { `${new Date(activity.created_at).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: 'numeric', minute: 'numeric' })}` }</li>
                </ul>
              : '' }
            </Col>
            <Col>
              <h3 style={{'margin':'20px 0 0'}}>che contiene le seguenti attività:</h3>
              { activityOperations && activityOperations.length > 0 ? 
                <ul className='withBullets'>
                  { activityOperations.map((op) => {
                    return (
                      <li key={op.id}>{ op.operation.descrizione }</li>
                    )
                  } )}
                </ul>
              : <p>Non ci sono attività</p> }
            </Col>
          </Row>
        : '' }
        <Row>
          <Col lg={ state && state.activity_id ? 8 : 12 } className="custom_form_wrapper">
            <form className="custom_form" onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col>
                  <label style={{'margin':'8px 0 18px'}}>Ubicazione &nbsp;&nbsp;&nbsp; <DynamicIcon iconName="FaInfoCircle" /> <i>Puoi cercare per nominativo o per matricola</i></label>
                  <AsyncSelect value={selectedLocation} name="location_id" isDisabled={false} isClearable={true} isRtl={false} cacheOptions defaultOptions={selectLocations} loadOptions={fetchOptions} onInputChange={handleInputChange} onChange={handleChange} />
                  <Button variant="primary" onClick={() => addLocation()} style={{'margin':'8px 0 18px'}}>Aggiungi</Button>
                </Col>
                <Col>
                  <div style={{'background':'#b2db8a','padding':'20px','margin':'0 25px 20px','borderRadius':'15px'}}>
                    <label><b>Duplica su{duplicates.length > 0 ? ' '+duplicates.length+' ubicazioni' : '' }:</b></label>
                    { duplicates.length > 0 ?
                      <ul className='withCmds'>
                        { duplicates.map((loc) => {
                          return (
                            <li key={loc.value}>{ loc.label } <Button className='onlyIcon' onClick={() => delLocation(loc.value)}><DynamicIcon iconName="FaTrash" /></Button></li>
                          )
                        }) }
                      </ul>
                    : <p>Non hai selezionato ubicazioni su cui duplicare</p> }
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button type="submit" variant="primary" className="waste_btn">Duplica</Button>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
        <Row className="action_bar bottom">
          <Col>
            <Button onClick={() => navigate(-1) } className="back"><DynamicIcon iconName="RiArrowGoBackFill" /> Torna indietro</Button>
            <Button onClick={() => navigate('/activities', { state: { page: (state && state.page ? state.page : 1), query: (state && state.query ? state.query : null) } })}><DynamicIcon iconName="IoIosArrowBack" /> Torna agli interventi</Button>
          </Col>
        </Row>
      </Container>
    </>
  );

}

export default ActivitiesDuplicate;